<template>
    <div>
        <div class="row top">
            <div class="row">
                <div class="col-md-2">
                    <back-button returnUrl="/home"></back-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <h4><u>Ανακοινώσεις</u></h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-7 create-col">
                    <button v-if="hasRight" class="cutomNewAnnouncement" @click="onGoToNewAnnouncement">Δημιουργία</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-1">
                    <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 grid-pad">
                    <DxDataGrid :data-source="announcements" :allow-column-reordering="true" :allow-column-resizing="true"
                        :column-auto-width="true" :show-borders="true" key-expr="Id" :show-row-lines="true"
                        :row-alternation-enabled="true">
                        <DxPaging :page-size="20" :enabled="false" />
                        <DxEditing :allow-updating="false" :use-icons="true" mode="cell" />
                        <DxHeaderFilter :visible="true" />
                        <DxFilterRow :visible="true" />
                        <DxSearchPanel :visible="true" />
                        <DxColumn caption="Τίτλος" data-field="Title" data-type="string" width="70%" :visible="true">
                        </DxColumn>
                        <DxColumn caption="Ημερομηνία Δημοσίευσης" data-field="DatePublished" sort-order="desc"
                            format="dd/M/yy HH:mm" data-type="datetime">
                        </DxColumn>
                        <DxColumn type="buttons">
                            <GridButton name="" hint="" icon="arrowright" :on-click="onDetailsClick" />
                            <GridButton v-if="hasRight" name="" hint="" icon="edit" :on-click="onEditClick" />
                            <GridButton v-if="hasRight" name="" hint="" icon="trash" :on-click="onDeleteConfirm" />
                        </DxColumn>
                    </DxDataGrid>
                </div>
            </div>
            <DxPopup :visible="deletePopUp.showPopUp" :drag-enabled="false" :close-on-outside-click="false"
                :show-title="true" :show-close-button="true" :width="800" :height="300" @hiding="onHiding"
                title="Θέλετε σίγουρα να διαγράψετε αυτή την ανακοίνωση;">
                <div class="row">
                    <h4 class="col-md-12 text-center">Παρακαλώ επιβεβαιώστε την διαγραφή</h4>
                    <div class="col-md-7">
                        <button class="btn btn-danger deleteBtn" @click="onDeleteClick(deletePopUp.rowId)">Διαγραφή</button>
                    </div>
                </div>
            </DxPopup>
        </div>
    </div>
</template>
<script>
import mainService from "../../services/mainService";
import BackButton from "../../components/shared/backButton";
import { DxPopup } from "devextreme-vue/popup";
import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxButton as GridButton,
} from "devextreme-vue/data-grid";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
export default {
    components: {
        BackButton,
        DxLoadIndicator,
        DxDataGrid,
        DxPaging,
        DxEditing,
        DxHeaderFilter,
        DxFilterRow,
        DxSearchPanel,
        DxColumn,
        GridButton,
        DxPopup
    },
    data() {
        return {
            announcements: [],
            loadIndicatorVisible: false,
            dataGridRefKey: "announcementsDataGrid",
            deletePopUp: {
                showPopUp: false,
                rowId: 0
            },
        }
    },
    async mounted() {
        this.loadIndicatorVisible = true;
        if (this.hasRight) {
            const result = await mainService.get(`/Announcements/GetAllAnnouncements`);
            this.announcements = result.data;
            this.announcements.filter(x => x.DatePublished == null).map(x => x.DatePublished = "Δεν έχει δημοσιευθεί ακόμα")
        }
        else {
            const result = await mainService.get(`/Announcements/GetAnnouncementsForOrganization?organizationId=${this.organizationId}`);
            this.announcements = result.data;
        }

        this.loadIndicatorVisible = false;
    },
    methods: {
        onDetailsClick(e) {
            this.$router.replace(`/Announcements/Details/${e.row.data.Id}`);
        },
        onEditClick(e) {
            this.$router.replace(`/Announcements/Edit/${e.row.data.Id}`);
        },
        async onDeleteClick(id) {
            if (id > 0) {
                this.announcements = this.announcements.filter(x => x.Id != id)
                await mainService.delete(`/Announcements/DeleteAnnouncement?id=${id}`)
                this.deletePopUp.showPopUp = false;
                this.deletePopUp.rowId = 0;
            }
        },
        onGoToNewAnnouncement() {
            this.$router.replace("/Announcements/Create");
        },
        onDeleteConfirm(e) {
            this.deletePopUp.showPopUp = true;
            this.deletePopUp.rowId = e.row.data.Id;
        },
        onHiding() {
            this.deletePopUp.showPopUp = false;
            this.deletePopUp.rowId = 0;
        }
    },
    computed: {
        hasRight() {
            return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin
        },
        organizationId() {
            return this.$store.getters.getSelectedOrganizationId;
        },
    }
}

</script>
<style lang="scss" scoped>
.create-col {
    padding-right: 10px;

    .cutomNewAnnouncement {
        margin-bottom: 1vw;
        border-radius: 7px;
        width: 170px;
        background-color: #6f81b4;
        padding: 7px;
        border: 0;

        &:active {
            background-color: #253769;
        }
    }
}

.deleteBtn {
    margin-top: 40px;
}
</style>